import axios from "axios";

const BASE_URL = 'PROD'

const apiMillennium = axios.create({
  baseURL: "https://api.santolabs.com.br/api/dasboard/millennium",
});

const apiLabs = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/dasboard/' : "https://api.santolabs.com.br/api/dasboard/",
});

const apiLabsV2 = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/v2/' : "https://api-v2.santolabs.com.br/api/v2",
});

const apiManagerSku = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/econsulta/' : "https://api.santolabs.com.br/api/econsulta/",
});
const apiEmbalei = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/embalei/' : "https://api.santolabs.com.br/api/embalei/",
});

// Consulta de pedidos do Embalei em LOTE (até 100 números por chamada).
// Host e token são próprios, separados do apiEmbalei acima.
//
// O token vem do .env (REACT_APP_TOKEN_EMBALEI_SANTOLABSV3) e é lido na
// subida do servidor: depois de mexer no .env, o `npm start` precisa ser
// reiniciado. Sem o valor, a API responde 401 e todo pedido é tratado como
// não embalado — o quadrante AG. EMBALAGEM incha sem dizer por quê, então o
// aviso abaixo sai no console.
const TOKEN_EMBALEI_V3 = process.env.REACT_APP_TOKEN_EMBALEI_SANTOLABSV3;

if (!TOKEN_EMBALEI_V3) {
  console.warn(
    "[api] REACT_APP_TOKEN_EMBALEI_SANTOLABSV3 não definido. " +
    "Copie o .env.example para .env, preencha o token e reinicie o npm start."
  );
}

const apiEmbaleiV3 = axios.create({
  baseURL: "https://new.santolabs.com.br/api/modulos/embalei",
  headers: { Authorization: `Bearer ${TOKEN_EMBALEI_V3}` },
});

const apiAttedance = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/dasboard/atendimento/' : "https://api.santolabs.com.br/api/dasboard/atendimento/",
});

const apiEbook = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/cursos/ebook/' : "https://api-cursos.santolabs.com.br/api/cursos/ebook/",
});

const apiSpreadsheet = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/v2/vtex/retiraja' : "https://api.santolabs.com.br/api/v2/vtex/retiraja",
});

const apiTelesales = axios.create({
  baseURL: "https://api.middleware.teste.santolabs.com.br/teleseals",
});

const apiOffers = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/v2/offers' : "https://api.santolabs.com.br/api/v2/offers",
});

const apiIDW = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/dasboard/idw' : "https://api.santolabs.com.br/api/dasboard/idw",
});

const apiSonar = axios.create({
  baseURL: 'http://santo.awslogistica.com.br:4436/datasnap/rest/tsm/Getfuncao'
})

const apiTelevendasBlue = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/televendas/bluesoft/' : "https://api.santolabs.com.br/api/televendas/bluesoft",
})

const apiTelevendasIDW = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/televendas/idw' : "https://api.santolabs.com.br/api/televendas/idw",
});

const apiSantoLog = axios.create({
  baseURL: BASE_URL === 'DEV' ? 'http://localhost:3001/api/santolog' : "https://api.santolabs.com.br/api/santolog",
});

export {
  apiMillennium,
  apiLabs,
  apiLabsV2,
  apiManagerSku,
  apiEmbalei,
  apiEmbaleiV3,
  apiAttedance,
  apiEbook,
  apiSpreadsheet,
  apiTelesales,
  apiOffers,
  apiIDW,
  apiSonar,
  apiTelevendasIDW,
  apiTelevendasBlue,
  apiSantoLog
};
